import { C } from '../theme'
import { RevealStagger } from './Reveal'
import { useContent } from '../content/ContentContext'
import { telHref } from '../content/derive'

export function Help() {
  const { home, settings } = useContent()
  const help = home.help ?? {}
  const steps = help.steps ?? []
  const tel = telHref(settings.contact?.phone)

  return (
    <section id="ayuda" aria-label={help.title ?? 'Ayuda'} className="sec" style={{ padding: '104px 40px' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <div style={{ maxWidth: 680, margin: '0 auto 56px', textAlign: 'center' }}>
          <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: '.18em', textTransform: 'uppercase', color: C.red, marginBottom: 18 }}>{help.eyebrow}</div>
          <h2 className="section-title" style={{ fontFamily: "'Spectral',serif", fontWeight: 400, fontSize: 46, lineHeight: 1.08, margin: '0 0 8px', color: C.ink, letterSpacing: '-.01em' }}>
            {help.title}
          </h2>
          <p style={{ fontSize: 17, lineHeight: 1.6, color: C.body, margin: '8px 0 0' }}>
            {help.body}
          </p>
          <p style={{ fontFamily: "'Spectral',serif", fontStyle: 'italic', fontSize: 16, color: C.muted, margin: '8px 0 0' }}>
            {help.subtitle}
          </p>
        </div>
        {steps.length > 0 && (
          <RevealStagger className="stack grid-3" style={{ display: 'grid', gridTemplateColumns: `repeat(${Math.min(steps.length, 3)},1fr)`, gap: 24, marginBottom: 48 }}>
            {steps.map((s, i) => (
              <div key={s.id ?? i} style={{ background: '#fff', border: `1px solid ${C.line}`, borderRadius: 10, padding: '32px 28px' }}>
                <div style={{ width: 46, height: 46, borderRadius: '50%', background: C.blue, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Spectral',serif", fontSize: 21, marginBottom: 20 }}>
                  {i + 1}
                </div>
                <h3 style={{ fontFamily: "'Spectral',serif", fontWeight: 500, fontSize: 22, margin: '0 0 10px', color: C.ink }}>{s.title}</h3>
                <p style={{ fontSize: 14.5, lineHeight: 1.65, color: C.body, margin: 0 }}>{s.text}</p>
              </div>
            ))}
          </RevealStagger>
        )}
        <div style={{ background: C.blue, borderRadius: 12, padding: '40px 44px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 32, flexWrap: 'wrap' }}>
          <div>
            <div style={{ fontFamily: "'Spectral',serif", fontSize: 26, color: '#fff', marginBottom: 6 }}>{help.bannerTitle}</div>
            <div style={{ fontSize: 15, color: 'rgba(234,241,251,.84)' }}>{help.bannerText}</div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap' }}>
            {tel && help.callCtaLabel && (
              <a className="btn" href={tel} style={{ background: '#fff', color: C.blue, fontWeight: 700, fontSize: 15, padding: '15px 28px', borderRadius: 3, textDecoration: 'none' }}>{help.callCtaLabel}</a>
            )}
            {help.messageCtaLabel && (
              <a className="btn" href="#contacto" style={{ border: '1.5px solid rgba(255,255,255,.7)', color: '#fff', fontWeight: 700, fontSize: 15, padding: '15px 28px', borderRadius: 3, textDecoration: 'none' }}>{help.messageCtaLabel}</a>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}
